import React from 'react';
import Tabs from '../../Tabs/Tabs.jsx';
import HongKongProfile from './HongKongProfile.jsx';
import SingaporeProfile from './SingaporeProfile.jsx';
import KlangProfile from './KlangProfile.jsx';
import BusanProfile from './BusanProfile.jsx';
import ChinaPortsProfiles from './ChinaPortsProfiles.jsx';
const labels = [
    "Hong Kong",
    "Shanghai & Shenzhen",
    "Singapore",
    "Busan",
    "Port Kelang"
];

const profiles = [
    <HongKongProfile />,
    <ChinaPortsProfiles />,
    <SingaporeProfile />,
    <BusanProfile />,
    <KlangProfile />    
];

export default class PortCityProfiles extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selected: 0 };
        this.handleTabClick = this.handleTabClick.bind(this);
    }
    handleTabClick(i) {
        this.setState({ selected: i});  
    }
    render() {
        return <div>
            <Tabs labels={labels} selected={this.state.selected} onTabClick={this.handleTabClick}/>
            {profiles[this.state.selected]}   
        </div>
    }    
}


// WEBPACK FOOTER //
// ./src/js/components/special/PortCityProfiles/PortCityProfiles.jsx